import classNames from "classnames";
import { ButtonCreatorConfig, createWidgetLinkPayload, createWidgetUiPayload } from "./utils";
import Simulator from "./Simulator";
import Code from "@/components/UI/Code/Code";

interface CodePageProps extends React.HTMLAttributes<HTMLElement> {
  onSettingsChange?: (nextSettings: ButtonCreatorConfig) => void;
  section: any;
  settings?: ButtonCreatorConfig;
}

const CodePage = ({ className, onSettingsChange, section, settings, ...props }: CodePageProps) => {
  return (
    <div className={classNames("flex divide-x", className)} {...props}>
      <div className="w-2/3 divide-y">
        <div className="flex flex-col divide-y" {...props}>
          <Code buttonProps={{ children: section?.CodeCopyButton?.Value }} tooltipProps={{ content: "Code copied" }}>
            {settings?.designType === "link-only" ? createWidgetLinkPayload(settings) : createWidgetUiPayload(settings)}
          </Code>
        </div>
      </div>
      <Simulator
        className="w-1/3"
        widgetProps={{
          id: "code-page-widget",
          ...settings,
        }}
      />
    </div>
  );
};

export default CodePage;
